.root {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 64px;
  height: var(--control-sm);
  touch-action: none;
  user-select: none;
  cursor: pointer;
}

.root[data-disabled] {
  cursor: default;
}

.track {
  position: relative;
  flex: 1;
  height: 4px;
  overflow: hidden;
  border-radius: var(--radius-full);
  background: var(--color-border-strong);
  transition: height var(--duration-fast) var(--ease-standard);
}

.root:hover .track,
.root:focus-within .track {
  height: 6px;
}

.secondary {
  position: absolute;
  inset-block: 0;
  left: 0;
  background: var(--color-text-subtle);
  opacity: 0.45;
}

.range {
  position: absolute;
  height: 100%;
  background: var(--color-accent);
}

.root[data-disabled] .range {
  background: var(--color-text-muted);
}

.thumb {
  display: block;
  width: 16px;
  height: 16px;
  border-radius: var(--radius-full);
  background: var(--color-surface-raised);
  border: 2px solid var(--color-accent);
  box-shadow: var(--shadow-sm);
  transition: transform var(--duration-fast) var(--ease-standard);
}

.root[data-disabled] .thumb {
  display: none;
}

.thumb:hover,
.thumb:focus-visible {
  transform: scale(1.15);
}

@media (pointer: coarse) {
  .thumb {
    width: 20px;
    height: 20px;
  }
}
